import { CP_PATH } from '../constants/cp-paths';

export const isDevMode = () => {
  return process.env.NODE_ENV === 'development';
};

export const isCP = () => {
  return window.location.pathname.includes(CP_PATH);
};

export const TENANT_OLX_PK = 'OLX-PK';

export const getTenantFromURL = () => {
  return process.env.REACT_APP_TENANT ?? TENANT_OLX_PK;
};
